<template>
    <w-card-form
        v-bind="formProps"
        v-on="formEvents"
    >
        <template slot="top">
            <!-- @slot top -->
            <slot name="top"></slot>
        </template>
        <!-- @slot Default slot for form field components (rendered before the email field component). -->
        <slot></slot>
        <v-flex xs12>
            <w-text-field
                icon="alternate_email"
                label="E-mail Address"
                autofocus
                :value="formData.email_address"
                :rules="[validationRules.generic.required, validationRules.email.valid, validationRules.email.minLength]"
                @enter="handleSubmit"
                @input="(val) => setFieldData('email_address', val)"
            ></w-text-field>
        </v-flex>
        <!-- @slot Additional form field components (rendered below the email field component). -->
        <slot name="additional"></slot>
        <template slot="actions">
            <!-- @slot Form actions. -->
            <slot name="actions"></slot>
        </template>
    </w-card-form>
</template>

<script>
    import WCardFormDataMixin from '../../mixins/forms/w-card-form-data-mixin'
    import WTextField from '../WTextField'
    import Logo from '../../assets/img/logo.png'

    const formData = () => ({
        email_address: ''
    })

    /**
     * Form component to allow a user to request their password to be reset.
     */
    export default {
        name: 'WAuthForgottenPasswordForm',
        mixins: [WCardFormDataMixin],
        components: {
            WTextField
        },
        data: () => ({
            formData: formData()
        }),
        props: {
            /**
             * Whether to center form text
             */
            align: {
                type: String,
                default: 'center'
            },
            /**
             * Text that the user clicks to go to the `alternativeRoute`.
             */
            alternativeText: {
                type: String,
                default: 'Do you want to login?'
            },
            /**
             * Provide a description at the top of the form.
             */
            description: {
                type: String,
                default: `Please enter the email address assigned to your account in order to receive an email with a
                    link to reset your password.`
            },
            /**
             * Hide the close icon.
             */
            hideCloseButton: {
                type: Boolean,
                default: true
            },
            /**
             * Path to logo.
             */
            logoSrc: {
                type: String,
                default: Logo
            },
            /**
             * Title of the form to display in the toolbar.
             */
            title: {
                type: String,
                default: 'Forgotten Password'
            }
        },
        methods: {
            initFormData: formData
        }
    }
</script>
